
import { useContext } from "react";
import CalendarsContext from "../../../context/NewCalendarContext/CalendarsContext";
import { cleardeleteNonWorkingDayModal } from "../../../context/NewCalendarContext/Actions";
import {Button, Dialog, DialogContent, TextField } from "@material-ui/core"
import styles from '../Calendars.module.css'
import { Formik, Form} from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import { 
            GET_NON_WORKING, DELETE_NON_WORKING, 
            GET_NON_WORKING_BY_DATE, 
            GET_COUNT_EVENT_NONWORKINGDAY,
            GET_NON_WORKING_BY_MONTH_YEAR 
        } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import moment from "moment";


const DeleteNonWorkingDay = ({calendarDate, date}:any) => {
   const {state, dispatch} = useContext(CalendarsContext)
   const [deleteCalendars] = useMutation(DELETE_NON_WORKING,{
    refetchQueries:[
                        {query:GET_NON_WORKING_BY_DATE, variables:{calendarId: parseInt(state._id), initDate: moment(date)}},
                        {query:GET_NON_WORKING_BY_MONTH_YEAR, variables:{
                                                                            calendarId: parseInt(state._id), 
                                                                            month: parseInt(moment(date).format('M')), 
                                                                            year: parseInt(moment(date).format('YYYY'))
                                                                        }},
                        {query:GET_NON_WORKING_BY_MONTH_YEAR, variables:{
                                                                            calendarId: parseInt(state._id), 
                                                                            month: parseInt(moment(date).format('M')), 
                                                                            year: parseInt(moment(date).format('YYYY'))
                                                                        }},
                        {query:GET_COUNT_EVENT_NONWORKINGDAY}
                  ]
  })
   const handleClose = ()=>{
    cleardeleteNonWorkingDayModal({}, dispatch);
   }
   const { loading, data } =  useQuery(GET_NON_WORKING, {
       variables: {
               id: state.idAux,
           }
   });
   
   if(loading) return null;
   const nonWorkingDay = data?.GET_NON_WORKING;
   const initialValues = () => {
       return {
           mensaje: ""
       }
   }

   return (
       <div>
       <Formik
         initialValues={initialValues()}
         validationSchema={validationSchema}
         onSubmit={formData => {
           const idDoc = Number(state.idAux) 
           deleteCalendars({
               variables:{
                deleteNonWorkingDayId:idDoc
               },
           }).then(()=>{
            SuccessfulAlert({text:"Día inhábil eliminado con éxito"});
            });
           handleClose();
         }}
       >
         {({
           values,
           errors,
           touched,
           handleChange,
           handleSubmit,
         }) => (
           <Dialog open={state.deleteNonWorkingDayModal} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth={true}>
               <div className={styles.dialogContainer}>
                   <div className={styles.centerContainer}>
                       <h3 id="form-dialog-title" data-testid="TitleModal">¿Confirmas eliminar el d&iacute;a inhábil?</h3>
                   </div>
                   <div className={styles.centerContainer}>
                       <span className={styles.tituloDatosUpdate}>{nonWorkingDay?.name}</span>
                   </div>
                   <div className={styles.centerContainer}>
                       <span className={styles.tituloNombreUpdate}>Una vez eliminado no podrás recuperar la información</span>
                   </div>
                   <div className={styles.centerContainer}>
                       <span className={styles.tituloNombreUpdate}>Escribe ELIMINAR en mayúsculas para confirmar</span>
                   </div>
                   <DialogContent>
                   <Form onSubmit = {handleSubmit}>
                       <TextField 
                           fullWidth 
                           className={styles.dialogFields} 
                           name="mensaje" 
                           label="Mensaje" 
                           variant="outlined" 
                           value = {values.mensaje}
                           onChange={handleChange}
                           error={touched.mensaje && Boolean(errors.mensaje)}
                           helperText = {touched.mensaje && errors.mensaje}
                           size="small" />
                       <div className={styles.centerContainer}>
                           <Button className="buttonCancel" onClick={() => handleClose()}>
                                   Cancelar
                           </Button>
                           <Button type="submit" className={styles.botonEliminar} style={{marginLeft: "20px", fontWeight:"bold"}}>
                               <span>Confirmar</span> 
                           </Button>
                       </div>
                       </Form>
                   </DialogContent>
               </div>
           </Dialog>
         )}
       </Formik>
     </div>

   )
}


const validationSchema = Yup.object().shape({
   mensaje: Yup.string().required("El  mensaje de confirmacion es requerido").oneOf(['ELIMINAR'], "El mensaje debe coincidir")
})

export default DeleteNonWorkingDay